import {
  LegacyPage,
  Model,
  LoadingContainer,
  Panels,
  Bar,
} from 'peach/components'
import { useParams } from 'peach/router'

import { useInternalListTemplateDescriptors } from 'core/types'

const CompanyDescriptors = () => {
  const { companyId } = useParams<{ companyId?: string }>()

  const {
    data: descriptors,
    isLoading,
    error,
  } = useInternalListTemplateDescriptors({
    companyId,
  })

  return (
    <LoadingContainer error={error} isLoading={isLoading}>
      <Panels header={<Bar title='Template Descriptors' />}>
        <LegacyPage.Full>
          <Model.List json={descriptors} title='Descriptors' />
        </LegacyPage.Full>
      </Panels>
    </LoadingContainer>
  )
}

export default CompanyDescriptors
